<ngb-alert [type]="'success'" [hidden]="!show" (closed)="hide()">
  {{ action?.message }}
  <a class="alert-link" (click)="undo()"> Undo </a>
</ngb-alert>
